import { memo, PropsWithChildren } from 'react';

import Tooltip from '@/ui/components/Tooltip';

const DisabledTooltip = ({ children }: PropsWithChildren) => {
  return (
    <Tooltip tooltipContent="This card has a pending operation. Actions are disabled until it is completed.">
      {children}
    </Tooltip>
  );
};

export default memo(DisabledTooltip);
